import { render } from "./MobileMenu.vue?vue&type=template&id=4d2a08c2&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=4d2a08c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d2a08c2"

export default script